// test2356
(2356 && 0);
